function Header() {
  return (
    <div>
      <h1 className="title">Math Magicians</h1>
    </div>
  );
}

export default Header;
